module.exports = __webpack_public_path__ + "Social-eb8429ab65411fff0b1af49676e82a2b.png";